import Icon from '@Shared/Icon';
import { IUser } from '@src/interfaces';
import React from 'react';
import { ListGroupItem } from 'react-bootstrap';

interface Props {
  user: IUser,
  active: number | null | undefined,
  setter: (user_id: number) => void
}

const ImpersonateUser: React.FC<Props> = (props) => {
  return (
    <ListGroupItem
      active={props.active == props.user.id}
      disabled={!!props.active}
      style={{
        paddingLeft: 44, position: 'relative', overflow: 'hidden',
        paddingRight: '15px'
      }}
      action
      onClick={() => {
        props.setter(props.user.id);
      }}
    >
      <Icon name={'user'} className='list-icon' style={{
        position: 'absolute',
        left: 12,
        top: 16,
        fontSize: 20
      }} />
      {props.user.name}
    </ListGroupItem>
  );
}

export default ImpersonateUser;